import { ANSWER_STATUSES, LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React from 'react';

import { isLessonInProgress } from 'common.components/lesson/utils';
import { RatioBar, RatioBarItem } from 'common.components/ratio-bar/ratio-bar';
import { ClessonProgressData } from 'store/clesson-results/utils';

import { b } from '../cn';

interface Props {
    status: LESSON_STATUS;
    isControlWork?: boolean;
    progressData?: ClessonProgressData;
    progressLoadingStatus?: LOADING_STATUSES;
}

const ratioBarColors = [
    { answerStatus: ANSWER_STATUSES.CORRECT, color: '#5ABB76' },
    { answerStatus: ANSWER_STATUSES.INCORRECT, color: '#FD8878' },
    { answerStatus: ANSWER_STATUSES.NOT_EVALUATED, color: '#A1A2A3' },
];

export const CalendarLessonCardProgress = ({ status, progressData, progressLoadingStatus }: Props) => {
    const isLoading = progressLoadingStatus === LOADING_STATUSES.LOADING;
    const isInProgress = isLessonInProgress(status);
    const { students, problems } = progressData || {};

    const textId = isInProgress
        ? 'lessons.calendar.progress.inProgress.text'
        : 'lessons.calendar.progress.finished.text';

    const ratioBarItems = ratioBarColors.reduce((items: RatioBarItem[], { answerStatus, color }) => {
        const value = problems?.items[answerStatus] || 0;

        if (value) {
            items.push({ color, value });
        }

        return items;
    }, []);

    return (
        <div className={b('progress-wrapper')}>
            <div className={b('progress-info')}>
                <Text id={textId} typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphSRegular} />
                {students && (
                    <Text
                        id="lessons.calendar.progress.value"
                        typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphSRegular}
                        values={{ value: students?.active, max: students?.max }}
                    />
                )}
            </div>
            <RatioBar items={ratioBarItems} max={problems?.max || 0} mix={b('progress-bar')} progress={isLoading} />
        </div>
    );
};
